import Types from "Types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { formatDocument, getBase64 } from "../../../../../../helpers/utils";
import {
  useDeleteDocument,
  useGetDocument,
} from "../../../../../../hooks/Documents";
import {
  useGetArchiveNetheos,
  useGetSyntheseDossier,
  usePostDossierParticulierDocument,
  useRouvrirDossierNetheos,
} from "../../../../../../hooks/DossierLocation";
import { useGetListSituationProfessionnelles } from "../../../../../../hooks/SituationProfessionnelle";
import { ActionCreators as DossierLocationActionCreators } from "../../../../../../redux/DossierLocation";
import { Selectors as PartenaireSelectors } from "../../../../../../redux/Partenaire";
import { Selectors as PiecesSelectors } from "../../../../../../redux/Pieces";
import { ActionCreators as SituationPersoActionCreators } from "../../../../../../redux/SituationPersonnelle";
import { ActionCreators as SituationProActionCreators } from "../../../../../../redux/SituationProfessionnelle";
import { DossierParticulierDetail } from "../../../../../../services/Api/swagger";
export const useInfoCandidat = (
  personne?: DossierParticulierDetail,
  refDossier?: string
) => {
  const archive = useSelector((state: Types.RootState) =>
    PiecesSelectors.getArchive(state)
  );

  const isControleDossier = useSelector((state: Types.RootState) =>
    PartenaireSelectors.getControleDossier(state)
  );
  const isCumulsUtilises = useSelector((state: Types.RootState) =>
    PartenaireSelectors.getCumulsUtilises(state)
  );

  const dispatch = useDispatch();
  const addGarant = (ref: string) =>
    dispatch(SituationPersoActionCreators.resetSituationPersoAndAddGarant(ref));
  const resetSituationPro = () =>
    dispatch(SituationProActionCreators.resetSituationProParcoursCreation());

  const resetSelectedPerson = () =>
    dispatch(DossierLocationActionCreators.resetSelectedPerson());
  // rouvrirDossierNetheos: (params) =>
  //   dispatch(PiecesActionCreators.rouvrirDossierNetheos.request(params)),

  const {
    mutate: mutateArchiveNetheos,
    isLoading: archiveFetching,
    error: archiveError,
  } = useGetArchiveNetheos();
  const getArchiveNetheos = (params: { ref: string; refPers: string }) => {
    mutateArchiveNetheos(params);
  };

  const { mutate: mutateRouvrirDossierNetheos } = useRouvrirDossierNetheos();
  const rouvrirDossierNetheos = (params: { ref: string; refPers: string }) => {
    mutateRouvrirDossierNetheos(params);
  };

  const handleDownloadArchive = () => {
    if (personne) {
      const params = {
        ref: personne.refDossierLocation || "",
        refPers: personne.reference || "",
      };
      getArchiveNetheos(params);
    }
  };

  const navigate = useNavigate();
  const postGarant = () => {
    if (personne && personne.refDossierLocation && personne.reference) {
      resetSituationPro();
      resetSelectedPerson();
      addGarant(personne.reference);
      navigate("/dossier-location/situation-personnelle");
    }
  };

  const modifyNetheos = () => {
    if (personne) {
      const params = {
        ref: personne.refDossierLocation || "",
        refPers: personne.reference || "",
      };
      if (personne.statut === "BLOQUE") {
        rouvrirDossierNetheos(params);
      }
      navigate("/dossier-location/pieces-justificatives");
    }
  };

  const { data: listSituationPro } = useGetListSituationProfessionnelles();

  // GESTION AJOUT DE DOCUMENT
  const {
    mutate: postDocument,
    error: errorDocument,
    isLoading: isFetchingDocument,
    isSuccess: isSuccessDocument,
  } = usePostDossierParticulierDocument();

  const [newDocument, setAddDocument] = useState<File | undefined>();
  const handlePostDocument = async () => {
    const document = await getBase64(newDocument);
    const buildDoc =
      document && newDocument && formatDocument(document, newDocument.name);
    if (buildDoc && refDossier && personne?.reference) {
      postDocument({
        dossierLocationRef: refDossier,
        dossierParticulierRef: personne.reference,
        fichier: buildDoc,
      });
    }
  };

  useEffect(() => {
    if (isSuccessDocument) {
      setAddDocument(undefined);
    }
  }, [isSuccessDocument]);

  const {
    mutate: getDocument,
    isLoading: isFetchingGetDocument,
    error: errorGetDocument,
  } = useGetDocument();

  // DELETE DOCUMENT

  const {
    mutate: deleteDocument,
    isLoading: isFetchingDeleteDocument,
    error: errorDeleteDocument,
    isSuccess: isSuccessDeleteDocument,
    reset: resetDeleteDocument,
  } = useDeleteDocument();

  const [idDocumentDelete, setIdDocumentDelete] =
    useState<number | undefined>();

  const handleDeleteDocument = () => {
    if (idDocumentDelete) {
      deleteDocument(idDocumentDelete);
    }
  };
  const handleCancelDeleteDocument = () => {
    resetDeleteDocument();
    setIdDocumentDelete(undefined);
  };

  const { mutate: getSyntheseDossier } = useGetSyntheseDossier();
  useEffect(() => {
    if (isSuccessDeleteDocument) {
      setIdDocumentDelete(undefined);
      refDossier && getSyntheseDossier(refDossier);
    }
  }, [isSuccessDeleteDocument]);
  return {
    getArchiveNetheos,
    archiveFetching,
    archiveError,
    addGarant,
    resetSituationPro,
    resetSelectedPerson,
    rouvrirDossierNetheos,
    archive,
    isControleDossier,
    isCumulsUtilises,
    errorDocument,
    isFetchingDocument,
    handlePostDocument,
    newDocument,
    setAddDocument,
    getDocument,
    isFetchingGetDocument,
    errorGetDocument,
    listSituationPro,
    modifyNetheos,
    postGarant,
    handleDownloadArchive,
    setIdDocumentDelete,
    handleDeleteDocument,
    isFetchingDeleteDocument,
    errorDeleteDocument,
    isSuccessDeleteDocument,
    resetDeleteDocument,
    idDocumentDelete,
    handleCancelDeleteDocument,
  };
};
